import React from 'react';
import Navbar from './navbar';
import logo from '../../image/logo.png';
import icon from '../../image/icone.png';
import { withRouter } from 'react-router-dom';
import './headerBreadcrumb.css';

const MainHeader = ({ user, location }) => {
  const { name } = user || {}; // Garante que user exista antes de acessar name

  // Mapear rotas para breadcrumbs com menu pai
  const routeMap = {
    '/': { name: 'Dashboard', icon: 'fa-tachometer-alt', parent: null },
    '/dashboard': { name: 'Dashboard', icon: 'fa-tachometer-alt', parent: null },
    '/contagemvolumetrica': {
      name: 'Contagem Volumétrica',
      parent: { name: 'Operação' },
    },
    '/conlogusuario': {
      name: 'Auditoria',
      parent: { name: 'Administração' },
    },
    '/cadcontrolador': { name: 'Controladores', parent: { name: 'Cadastro' } },
    '/cadplano': {
      name: 'Planos do Controlador',
      parent: { name: 'Operação' },
    },
    '/cadintervalo': { name: 'Intervalos', parent: { name: 'Cadastro' } },
    '/cadtrocaplano': {
      name: 'Tabela de Troca de Plano',
      parent: { name: 'Operação' },
    },
    '/cadusuario': { name: 'Usuários', parent: { name: 'Cadastro' } },
    '/cadgrupo': {
      name: 'Grupos de Usuário',
      parent: { name: 'Cadastro' },
    },
    '/cadgrupofisico': {
      name: 'Grupos Físicos',
      parent: { name: 'Cadastro' },
    },
    '/caddetector': { name: 'Detectores', parent: { name: 'Cadastro' } },
    '/caddataespecial': {
      name: 'Datas Especiais',
      parent: { name: 'Operação' },
    },
    '/cadtipoalarme': {
      name: 'Tipos de Alarme',
      parent: { name: 'Cadastro' },
    },
    '/pluviometro': {
      name: 'Índice Pluviométrico',
      parent: { name: 'Dispositivos' },
    },
    '/mapadefases': { name: 'Mapa de Fases' },
    '/transito': { name: 'Trânsito' },
    '/mapa-waze': { name: 'Mapa Waze' },
    '/temporealdashboard': {
      name: 'Tempo Real',
      parent: { name: 'Monitoramento' },
    },
    '/planoforcado': {
      name: 'Plano Forçado',
      parent: { name: 'Monitoramento' },
    },
    '/adaptativo': { name: 'Adaptativo', parent: { name: 'Monitoramento' } },
    '/logadaptativo': {
      name: 'Log Adaptativo',
      parent: { name: 'Relatórios' },
    },
    '/caderrogeral': { name: 'Erro Geral', parent: { name: 'Relatórios' } },
    '/caderro': {
      name: 'Erros de Controlador',
      parent: { name: 'Relatórios' },
    },
    '/sap': { name: 'Seleção Automática', parent: { name: 'Configurações' } },
    '/telegram': {
      name: 'Telegram',
      parent: { name: 'Comunicação' },
    },
    '/log-adaptativo': {
      name: 'Histórico Adaptativo',
      parent: { name: 'Operação' },
    },
    '/execplanoforcado': {
      name: 'Plano Forçado',
      parent: { name: 'Operação' },
    },
    '/concontroladorerrogeral': {
      name: 'Notificações',
    },
    '/concontroladorerro': {
      name: 'Registro de Defeitos',
      parent: { name: 'Operação' },
    },
    '/pluviometro-tempo-real': {
      name: 'Tempo Real',
      parent: { name: 'Índice Pluviométrico' },
    },
    '/pluviometro-historico': {
      name: 'Histórico',
      parent: { name: 'Índice Pluviométrico' },
    },
    '/pluviometro-mapa': {
      name: 'Mapa',
      parent: { name: 'Índice Pluviométrico' },
    },
    '/ticketsuporte': {
      name: 'Tickets de Suporte',
      parent: { name: 'Manutenção' },
    },
    '/cameradeteccao': {
      name: 'Câmera de Detecção',
      parent: { name: 'Câmeras' },
    },
    '/cameramonitoramento': {
      name: 'Câmera Monitoramento',
      parent: { name: 'Câmeras' },
    },
    '/cadcamera': {
      name: 'Cadastro de Câmeras',
      parent: { name: 'Câmeras' },
    },
    '/manutencao-os': {
      name: 'Ordens de Serviço',
      parent: { name: 'Manutenção' },
    },
    '/manutencao-mapa': {
      name: 'Mapa de OS',
      parent: { name: 'Manutenção' },
    },
    '/manutencao-mapa-viaturas': {
      name: 'Mapa de Viaturas',
      parent: { name: 'Manutenção' },
    },
    '/manutencao-equipes': {
      name: 'Equipes',
      parent: { name: 'Manutenção' },
    },
    '/manutencao-viaturas': {
      name: 'Viaturas',
      parent: { name: 'Manutenção' },
    },
    '/manutencao-estoque': {
      name: 'Estoque',
      parent: { name: 'Manutenção' },
    },
    '/manutencao-inventario': {
      name: 'Inventário',
      parent: { name: 'Manutenção' },
    },
  };

  let currentRoute = routeMap[location.pathname] || { name: 'Página', icon: 'fa-file' };
  if (location.pathname.startsWith('/controlador-manutencao/')) {
    currentRoute = {
      name: 'Histórico de manutenção',
      parent: { name: 'Controlador' },
    };
  }

  return (
    <header className="main-header">
      <a href="/#/" className="logo">
        <span className="logo-mini">
          <img src={icon} height="40" alt="" />
        </span>
        <span className="logo-lg">
          <img src={logo} height="40" alt="" />
        </span>
      </a>
      <nav className="navbar navbar-static-top">
        <a href="/" className="sidebar-toggle" role="button" aria-label="Toggle sidebar" onClick={e => e.preventDefault()}>
          <span className="sr-only">Toggle sidebar</span>
        </a>

        <div className="header-breadcrumb">
          <ol className="breadcrumb">
            {currentRoute.parent && <li className="active">{currentRoute.parent.name}</li>}
            <li className="active">{currentRoute.name}</li>
          </ol>
        </div>
        <div className="navbar-custom-menu">
          <ul className="nav navbar-nav">
            <li className="header-user-greeting">
              <span
                className="user-greeting"
                style={{
                  color: 'white',
                  fontSize: '16px',
                }}
              >
                Olá, {name || 'Usuário'}
              </span>
            </li>
          </ul>
          <Navbar />
        </div>
      </nav>
    </header>
  );
};

export default withRouter(MainHeader);
